import Button from "@app/components/button";
import JobListItem from "@app/components/careers/job-list-item";
import FormFieldCheckbox from "@app/components/form/checkbox";
import FormFieldDropdown from "@app/components/form/dropdown";
import FormFieldInput from "@app/components/form/input";
import GradientContainer from "@app/components/gradient/gradient-container";
import { frontendApi } from "@app/lib/api";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { Field, Form } from "react-final-form";
import { mdiBellRingOutline, mdiClose, mdiEmail, mdiMessage, mdiRssBox } from '@mdi/js';
import Icon from "@mdi/react";
import { Z_INDECES } from "@app/constants/default";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import { useThemeContext } from "@app/contexts/theme-context";

type searchFilterType = {
  keyword: string,
  jobType: string,
  location: string,
  posted: string,
  category: string,
}

const convertJobType = (jobTypeId: string) => {
  switch (jobTypeId) {
    case "1":
      return "Freelance"
    case "2":
      return "Full-time"
    case "3":
      return "Part-time"
    case "4":
      return "Internship"
    default:
      return ""
  }
};

const convertPostedDate = (postedDateId: string) => {
  switch (postedDateId) {
    case "1":
      return "Today"
    case "2":
      return "Since Yesterday"
    case "3":
      return "Less than 7 days ago"
    case "4":
      return "Less than 30 days ago"
    default:
      return ""
  }
}

const convertCategory = (categoryId: string) => {
  switch (categoryId) {
    case "1":
      return "Default"
    default:
      return ""
  }
}

const RadioButton = ({ groupName, value, label }) => {
  return (
    <Field name={groupName} type="input">
      {({ input, meta }) => (
        <div className="flex flex-row space-x-1 items-center">
          <input
            className={`h-4 w-4 border-1 border-gray-300
         text-secondary
         checked:border-white
         checked:bg-secondary
         checked:ring-secondary
          checked:ring-1
        `}
            {...input}
            value={value}
            type="radio"
            required
          />
          <p className="text-body-md text-text-color-mid-em">{label}</p>
        </div>
      )}
    </Field>
  )
};

const CareersPage = () => {
  const [isAdvance, setIsAdvance] = useState(false);
  const [jobsList, setJobsList] = useState([]);
  const [totalJobs, setTotal] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [isLoadMoreLoading, setLoadMoreLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(2);
  const [isAdvanceSearchResult, setIsAdvanceSearchResult] = useState(false)
  const [currentUrl, setCurrentUrl] = useState('web/jobs?take=10')
  const [searchFilters, setSearchFilters] = useState<searchFilterType>()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isMobile, isTablet } = useThemeContext();


  const getJobs = async () => {
    try {
      setLoading(true)
      await frontendApi.get(currentUrl)
        .then((res) => {
          setJobsList(res.data.jobs)
          setTotal(res.data.total)
        })
        .catch((err) => console.error(err ? err : 'Something went wrong'))
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = async () => {
    setLoadMoreLoading(true)

    try {
      await frontendApi.get(`${currentUrl}&page=${currentPage}`)
        .then((res) => setJobsList(jobsList.concat(res.data.jobs)))
        .catch((err) => console.error(err ? err : 'Something went wrong'))
    } catch (err) {
      console.error(err);
    } finally {
      setLoadMoreLoading(false);
      setCurrentPage(currentPage + 1)
    }
  };

  const submitSearch = async (payload) => {
    const {
      keyword,
      location,
      parttime,
      fulltime,
      internship,
      freelance,
      jobType,
      posted,
      fromBrowseButton
    } = payload
    let typeQuery = '';
    let locQuery = ''
    let keywordQuery = ''
    let postedQuery = ''
    let arr = [
      { type: freelance, id: 1 },
      { type: fulltime, id: 2 },
      { type: internship, id: 3 },
      { type: parttime, id: 4 },
    ];
    const checkedType = arr.filter((d) => d.type)

    if (!isEmpty(keyword)) {
      keywordQuery = `&keyword=${keyword}`
    };
    if (!isEmpty(location)) {
      locQuery = `&location=${location}`
    };

    if (isAdvance) {
      if (jobType) typeQuery = `&types=${jobType}`
    } else {
      if (checkedType.length === 1) {
        typeQuery = `&types=${checkedType[0].id}`
      }
      if (checkedType.length > 1) {
        typeQuery = '&types='
        checkedType.map((c, i) => typeQuery += `${c.id}${checkedType.length > (i + 1) ? ';' : ''}`)
      }
    };

    if (posted) postedQuery = `&dateCreated=${posted}`;

    let query = `${keywordQuery}${locQuery}${typeQuery}${postedQuery}`;
    const url = `web/jobs?take=10${query}`;

    try {
      setLoading(true)
      setSearchFilters(payload);
      await frontendApi.get(url)
        .then((res) => {
          setJobsList(res.data.jobs)
          setTotal(res.data.total)
        })
        .catch((err) => console.error(err ? err : 'Something went wrong'))
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      if (isAdvance) setIsAdvanceSearchResult(true);
      if (fromBrowseButton) {
        setIsAdvanceSearchResult(false)
        setIsAdvance(false)
      }
      setCurrentUrl(url)
    }
  }

  useEffect(() => {
    getJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const defaultModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '0.375rem',
      minWidth: isMobile ? '60vw' : isTablet ? '50vw' : '40vw',
      maxWidth: isMobile ? '80vw' : isTablet ? '70vw' : '40vw',
      maxHeight: '90vh',
      overlfow: 'auto',
      zindex: Z_INDECES.MODAL,
    },
    overlay: {
      zIndex: Z_INDECES.MODAL_OVERLAY,
      backdropFilter: 'blur(3px)'
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  }


  const SearchFilterDispay = ({ title, value, id }) => {
    return (
      <div
        className="items-center flex flex-row 
      space-x-1 label-md text-light justify-between rounded-2xl px-3 py-[6px]"
        style={{
          backgroundColor: (isLoading || isLoadMoreLoading) ? '#64748b' : '#0E7490',
        }}
      >
        <div>
          {title}: <span className="label-sm">{value}</span>
        </div>
        <button
          disabled={isLoading || isLoadMoreLoading}
          type="button"
          className="disabled:cursor-not-allowed"
          onClick={() => {
            const searchFiltersClone = { ...searchFilters }
            searchFiltersClone[id] = ''
            submitSearch(searchFiltersClone);
          }}
        >
          <div className="-mb-px"><Icon path={mdiClose} size={0.6} /></div>
        </button>
      </div>
    )
  };

  const subscribeToSearch = async (payload) => {
    const { jobType, posted, keyword, location } = searchFilters
    const { email, emailsched } = payload
    const convertedJobtype = convertJobType(jobType)
    const convertedPostedDate = convertPostedDate(posted)

    const body = {
      "email": email,
      "keyword": keyword,
      "location": location,
      "jobType": convertedJobtype,
      "posted": convertedPostedDate,
      "frequency": emailsched
    }

    await frontendApi.post('web/signup-notifications', body)
      .then((res) => {
        toast.success(res.data.message);
        handleModalClose();
      })
      .catch((err) => toast.error('Something went wrong'))
  }

  return (
    <section>
      <div className="flex flex-col">
        <div className="flex flex-col space-y-1 py-8 sm:p-7 md:px-16 xl:px-32 bg-background-low-em w-full">
          <div className="flex flex-col justify-center -mb-2 sm:flex-row sm:justify-between items-center">
            <h1 className="h5 lg:h3 px-2 text-center pb-2 xs:px-6 sm:p-0 text-background-primary-dark">Careers - {isAdvance ? 'Advanced Search' : 'Browse'}</h1>
            <GradientContainer overrideClassName="sm:hidden h-2 mb-6 w-[40%]" />
            {isAdvance ?
              <Button
                onClick={() => {
                  setIsAdvance(false)
                  setIsAdvanceSearchResult(false)
                  submitSearch({ keyword: '', location: '', fromBrowseButton: true })
                }}
                buttonType="secondary"
                className="!py-1.5"
              >
                Browse
              </Button>
              :
              <Button onClick={() => {
                setIsAdvance(true)
                setJobsList([])
              }} buttonType="secondary" className="!py-1.5">Advanced Search</Button>
            }
          </div>
          <div className="hidden sm:flex justify-center sm:justify-start sm:pt-0">
            <GradientContainer overrideClassName="h-2 mt-2 w-[40%] md:w-[20%] lg:w-[15%]" />
          </div>
        </div>
        <Form
          onSubmit={submitSearch}
          render={({
            handleSubmit, submitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="mx-5 sm:mx-7 md:mx-16 xl:mx-32 my-5 sm:my-10 flex flex-col space-y-3 sm:space-y-4">
                {isAdvanceSearchResult ? (
                  <div className="grid grid-cols-2  gap-3 lg:flex lg:flex-row lg:gap-0 lg:space-x-3 lg:overflow-auto ">
                    {searchFilters.keyword && (
                      <SearchFilterDispay value={searchFilters.keyword} title="Keyword" id="keyword" />
                    )}
                    {searchFilters.location && (
                      <SearchFilterDispay value={searchFilters.location} title="Location" id="location" />
                    )}
                    {searchFilters.jobType && (
                      <SearchFilterDispay value={convertJobType(searchFilters.jobType)} title="Job Type" id="jobType" />
                    )}
                    {searchFilters.category && (
                      <SearchFilterDispay value={convertCategory(searchFilters.category)} title="Category" id="category" />
                    )}
                    {searchFilters.posted && (
                      <SearchFilterDispay value={convertPostedDate(searchFilters.posted)} title="Posted" id="posted" />
                    )}
                  </div>
                ) : (
                  <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-2">
                    <FormFieldInput
                      blockClassName="w-full"
                      name="keyword"
                      label=""
                      placeholder="&#x1F50D; Search Keyword"
                    />
                    <FormFieldInput
                      blockClassName="w-full"
                      name="location"
                      label=""
                      placeholder="&#x1F4CD; Location"
                    />
                    <div className={`${isAdvance ? 'hidden sm:flex' : 'flex'} justify-center sm:justify-start items-center sm:pl-3`}>
                      <Button type="submit" disabled={submitting} className="!rounded-2xl w-full sm:w-auto">
                        {submitting ? 'Searching...' : 'Search'}
                      </Button>
                    </div>
                  </div>
                )}
                {(isAdvance && !isAdvanceSearchResult) && (
                  <div className="flex flex-col sm:flex-row sm:space-x-2 space-y-4 sm:space-y-0">
                    <FormFieldDropdown
                      name="jobType"
                      options={[
                        { name: 'Freelance', value: 1 },
                        { name: 'Full-time', value: 2 },
                        { name: 'Internship', value: 3 },
                        { name: 'Part-time', value: 4 },
                      ]}
                      selectId="job-type"
                      placeholder="Job Type"
                      label=""
                    />
                    <FormFieldDropdown
                      name="category"
                      options={[
                        { name: 'Default', value: 1 },
                      ]}
                      selectId="job-category"
                      placeholder="Category"
                      label=""
                    />
                    <FormFieldDropdown
                      name="posted"
                      options={[
                        { name: 'Today', value: 1 },
                        { name: 'Since Yesterday', value: 2 },
                        { name: 'Less than 7 days ago', value: 3 },
                        { name: 'Less than 30 days ago', value: 4 },
                      ]}
                      selectId="posted"
                      label=""
                      placeholder="Date Posted"
                    />
                    <div className="sm:hidden flex justify-center sm:justify-start items-center sm:pl-3">
                      <Button type="submit" disabled={submitting} className="!rounded-2xl w-full sm:w-auto">
                        {submitting ? 'Searching...' : 'Search'}
                      </Button>
                    </div>
                  </div>
                )}
                {
                  isAdvanceSearchResult && (
                    <div className="flex flex-row space-x-3">
                      <Button
                        className="!rounded-2xl"
                        onClick={() => setIsAdvanceSearchResult(false)}
                      >
                        Refine Search
                      </Button>
                      <Button
                        buttonType="secondary"
                        onClick={() => setIsModalOpen(true)}
                        startIcon={<Icon path={mdiBellRingOutline} size={0.8} />}
                      >
                        Subscribe to this earch
                      </Button>

                    </div>
                  )
                }
                {!isAdvance && (
                  <div className="grid grid-cols-2 sm:flex sm:flex-row sm:space-x-2 sm:ml-2">
                    <FormFieldCheckbox name='freelance' label="Freelance" />
                    <FormFieldCheckbox name='fulltime' label="Full-time" />
                    <FormFieldCheckbox name='internship' label="Internship" />
                    <FormFieldCheckbox name='parttime' label="Part-time" />
                  </div>
                )}
                {isLoading ? (
                  <div className="flex flex-row py-10 space-x-5 items-center">
                    <div className="h-px flex flex-grow bg-[#EAECF0]" />
                    <p className="text-[#667085]">Loading...</p>
                    <div className="h-px flex flex-grow bg-[#EAECF0]" />
                  </div>
                ) : (
                  jobsList.map((job) => (
                    <JobListItem
                      id={job.id}
                      key={job.id}
                      name={job.title}
                      date={job.created_at}
                      location={job.location}
                      status={job.type.name}
                    />
                  ))
                )}
                {(!isLoading && jobsList.length >= totalJobs) && (
                  <div className="flex flex-row py-10 space-x-5 items-center">
                    <div className="h-px flex flex-grow bg-[#EAECF0]" />
                    <p className="text-[#667085]">That&apos;s all of it!</p>
                    <div className="h-px flex flex-grow bg-[#EAECF0]" />
                  </div>
                )}
                {((jobsList.length < totalJobs) && !isLoading && jobsList.length !== 0) && (
                  <div className="flex flex-row py-10 space-x-5 items-center">
                    <div className="h-px flex flex-grow bg-[#EAECF0]" />
                    <button
                      type="button"
                      disabled={isLoadMoreLoading}
                      onClick={() => loadMore()}
                      className="px-4 py-[10px] cursor-pointer border 
                  rounded-xl disabled:cursor-not-allowed disabled:bg-gray-100"
                    >
                      <p className="text-[#344054]">{isLoadMoreLoading ? 'Loading...' : 'Load More'}</p>
                    </button>
                    <div className="h-px flex flex-grow bg-[#EAECF0]" />
                  </div>
                )}
              </div>
            </form>
          )}
        />
        <ReactModal
          isOpen={isModalOpen} contentLabel="testa" style={defaultModalStyles}
          shouldCloseOnOverlayClick shouldCloseOnEsc onRequestClose={handleModalClose}
        >
          <Form
            onSubmit={subscribeToSearch}
            render={({
              handleSubmit, submitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col">
                  <div className="flex flex-col space-y-2">
                    <div className="flex flex-row justify-between ">
                      <div>
                        <p className="subheading text-text-color-high-em">Subscribe to Personalized Notifications</p>
                      </div>
                      <div className="-mt-3 -mr-3">
                        <button type="button" onClick={() => handleModalClose()}>
                          <Icon path={mdiClose} size={0.8} />
                        </button>
                      </div>
                    </div>
                    <p className="text-body-sm text-text-color-mid-em">
                      You are subscribing to jobs matching your current search criteria.
                    </p>
                  </div>
                  <div className="flex flex-col pt-6 space-y-2">
                    <div className="flex flex-row space-x-2 items-center">
                      <div className=""><Icon path={mdiEmail} size={0.8} /></div>
                      <p className="label-md text-text-color-high-em">Email Notifications</p>
                    </div>
                    <div className="pt-1 flex-col flex sm:flex-row sm:space-x-2">
                      <p className="text-body-md text-text-color-mid-em">Email Notifications will be sent to you:</p>
                      <div className="flex flex-row space-x-3 ">
                        <RadioButton groupName="emailsched" value="daily" label="Daily" />
                        <RadioButton groupName="emailsched" value="weekly" label="Weekly" />
                      </div>
                    </div>
                    <div className="space-y-2 sm:space-y-0 flex flex-col sm:flex-row sm:items-center sm:space-x-3">
                      <FormFieldInput
                        blockClassName="w-full"
                        name="email"
                        label=""
                        placeholder="Email address"
                        required
                        type="email"
                      />
                      <div>
                        <Button
                          type="submit"
                        >
                          Subscribe</Button>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col pt-4 space-y-2">
                    <div className="flex flex-row space-x-2 items-center">
                      <div className=""><Icon path={mdiRssBox} size={0.8} /></div>
                      <p className="label-md text-text-color-high-em">Custom RSS Feed</p>
                    </div>
                    <p className="text-body-md text-text-color-mid-em">
                      Your personalized RSS Feed is below,
                      copy the address to your RSS reader.
                    </p>
                    <div className="space-y-2 sm:space-y-0 flex flex-col sm:flex-row sm:items-center sm:space-x-2">
                      <div className="sm:w-[60%] lg:w-[50%] xl:w-[60%] 2xl:w-[70%]">
                        <FormFieldInput
                          blockClassName="w-full"
                          name="rss-code"
                          label=""
                          readonly
                          initialValue="https://simplewaste.com/wpjobboard/xml/rss/?"
                        />
                      </div>
                      <div>
                        <Button
                          onClick={() => {
                            navigator.clipboard.writeText('https://simplewaste.com/wpjobboard/xml/rss/?')
                            toast.success('Successfully Copied RSS address');
                          }}
                        >
                          Copy RSS address
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            )}
          />
        </ReactModal>
      </div>
    </section>
  );
};
export default CareersPage;
